import type { ReactNode } from 'react';

import type { FormUsageContext } from '#/components/Form/Form';
import { StyledNativeLinkWithRef } from '#/components/Link/StyledNativeLinkWithRef';
import { StyledVersionedRouterLink } from '#/components/Link/StyledVersionedRouterLink';
import { trackClicked } from '#/utils/analytics/track/trackClicked';

type Props = {
  formUsageContext: FormUsageContext;
  email: string;
  children?: ReactNode;
  showLoginModal?: (email: string) => void;
  getLoginUrlAndState: (email?: string) => {
    to: string;
    state: Record<string, unknown>;
  };
  qaId?: string;
};

export function SignupFormLoginLink({
  formUsageContext,
  email,
  children,
  showLoginModal,
  getLoginUrlAndState,
  qaId,
}: Props) {
  if (formUsageContext === 'modal' && showLoginModal) {
    return (
      <StyledNativeLinkWithRef
        href="#"
        onClick={(e) => {
          e.preventDefault();
          trackClicked('Log In');
          showLoginModal(email);
        }}
        qaId={qaId}
      >
        {children}
      </StyledNativeLinkWithRef>
    );
  }

  const loginUrlAndState = getLoginUrlAndState(email);

  return (
    <StyledVersionedRouterLink
      to={loginUrlAndState.to}
      state={loginUrlAndState.state}
      onClick={() => {
        trackClicked('Log In');
      }}
      qaId={qaId}
    >
      {children}
    </StyledVersionedRouterLink>
  );
}
